import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import {
  CustomMealPlanRoot,
  ContentWrapper,
  BackgroundImage,
  DesktopImage,
  MobileImage,
  Title,
  DescriptionWrapper,
} from './CustomMealPlan.styles'
import customMealPlanDesktop from '../../../../../../../../public/assets/recipes/categories/individual/box-background.webp'
import customMealPlanMobile from '../../../../../../../../public/assets/recipes/categories/individual/box-background-m.webp'
import Trans from 'next-translate/Trans'
import Link from 'next/link'
import { Button } from 'components/Button'

export const CustomMealPlan: React.FC = () => {
  const { t } = useTranslation('products')

  return (
    <CustomMealPlanRoot>
      <BackgroundImage>
        <DesktopImage>
          <Image src={customMealPlanDesktop} alt={t('recipes:individual.expect.background-img')} />
        </DesktopImage>
        <MobileImage>
          <Image src={customMealPlanMobile} alt={t('recipes:individual.expect.background-img')} />
          <Title>{t('products:customMealPlan.title-mobile')}</Title>
        </MobileImage>
        <ContentWrapper>
          <Text
            as="h2"
            align="center"
            size="h2"
            weight="semiBold"
            color="accent-white"
            css={{ marginBottom: '$2' }}
          >
            {t('products:customMealPlan.title')}
          </Text>
          <Text
            align="center"
            size='bodyExtraLarge'
            color="accent-white"
            css={{ marginBottom: '$4' }}
          >
            <Trans i18nKey={'products:customMealPlan.description'} components={{ br: <br /> }} />
          </Text>
          <Link href="/meal-plan">
            <Button>{t('products:customMealPlan.ctaText')}</Button>
          </Link>
        </ContentWrapper>
      </BackgroundImage>
      <DescriptionWrapper>
        <Text align="center" weight="semiBold" size="bodyExtraLarge" color="accent-black">
          <Trans
            i18nKey={'products:customMealPlan.description-mobile'}
            components={{ br: <br /> }}
          />
        </Text>
        <Link href="/meal-plan">
          <Button>{t('products:customMealPlan.ctaText')}</Button>
        </Link>
      </DescriptionWrapper>
    </CustomMealPlanRoot>
  )
}
